const appLayoutLang = {
	btn_back_to_irp: {
		tag: 'app.layout.btn_back_to_irp',
		fr: 'Retour au portail investisseur',
		en: 'Back to investor portal',
	},
};

export default appLayoutLang;
